import { render, staticRenderFns } from "./BbppProductServicesC.vue?vue&type=template&id=7a7ac78c"
import script from "./BbppProductServicesC.vue?vue&type=script&lang=js"
export * from "./BbppProductServicesC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports